import { createTheme } from "@mantine/core";

export const appTheme = createTheme({
  autoContrast: true,
  breakpoints: {
    xs: "30em",
    sm: "48em",
    md: "64em",
    lg: "80em",
    xl: "96em",
  },
  colors: {
    analyticsBlue: [
      "#f3f7ff",
      "#e8f0ff",
      "#ccddff",
      "#a9c6ff",
      "#82acff",
      "#5b91f7",
      "#3478e5",
      "#2662c2",
      "#214f98",
      "#1f437a",
    ],
  },
  cursorType: "pointer",
  defaultRadius: "sm",
  fontFamily: "Inter, ui-sans-serif, system-ui, sans-serif",
  fontSizes: {
    xs: "0.6875rem",
    sm: "0.75rem",
    md: "0.875rem",
    lg: "1rem",
    xl: "1.125rem",
  },
  focusRing: "auto",
  headings: {
    fontFamily: "Inter, ui-sans-serif, system-ui, sans-serif",
    fontWeight: "650",
    sizes: {
      h1: { fontSize: "1.125rem", lineHeight: "1.3" },
      h2: { fontSize: "1rem", lineHeight: "1.35" },
      h3: { fontSize: "0.9375rem", lineHeight: "1.4" },
      h4: { fontSize: "0.875rem", lineHeight: "1.4" },
      h5: { fontSize: "0.8125rem", lineHeight: "1.4" },
      h6: { fontSize: "0.75rem", lineHeight: "1.4" },
    },
    textWrap: "balance",
  },
  primaryColor: "analyticsBlue",
  primaryShade: 6,
  radius: {
    xs: "0.25rem",
    sm: "0.375rem",
    md: "0.5rem",
    lg: "0.75rem",
    xl: "1rem",
  },
  respectReducedMotion: true,
  spacing: {
    xs: "0.375rem",
    sm: "0.625rem",
    md: "0.875rem",
    lg: "1.25rem",
    xl: "1.75rem",
  },
});
